/**
 * Adventure Categories API Endpoints
 * API service for adventure category management (admin)
 */

import { ApiService } from '../apiService'
import type {
  AdventureCategoryDto,
  UserFlagDto,
  CriteriaTypeDto,
  NodeTypeDto,
  ListCategoriesParams,
  CreateCategoryRequest,
  UpdateCategoryRequest,
} from '../types/adventureCategory'

export const adventureCategoriesApi = {
  // ===================
  // CATEGORIES
  // ===================

  /** Get all adventure categories */
  getCategories: (params?: ListCategoriesParams) =>
    ApiService.get<AdventureCategoryDto[]>('/admin/adventure-categories', params),

  /** Get single category with full details */
  getCategory: (id: number) =>
    ApiService.get<AdventureCategoryDto>(`/admin/adventure-categories/${id}`),

  /** Create a new category */
  createCategory: (data: CreateCategoryRequest) =>
    ApiService.post<AdventureCategoryDto>('/admin/adventure-categories', data),

  /** Update an existing category */
  updateCategory: (id: number, data: UpdateCategoryRequest) =>
    ApiService.put<AdventureCategoryDto>(`/admin/adventure-categories/${id}`, data),

  /** Delete a category */
  deleteCategory: (id: number) =>
    ApiService.delete<void>(`/admin/adventure-categories/${id}`),

  // ===================
  // REFERENCE DATA
  // ===================

  /** Get all user flags for dropdown */
  getUserFlags: () =>
    ApiService.get<UserFlagDto[]>('/admin/users/flags'),

  /** Get all criteria types for multi-selects */
  getCriteriaTypes: () =>
    ApiService.get<CriteriaTypeDto[]>('/api/Adventures/CriteriaTypes'),

  /** Get all node types for multi-select */
  getNodeTypes: () =>
    ApiService.get<NodeTypeDto[]>('/api/adventures/nodetypes'),
}
